import { render, staticRenderFns } from "./new-password.vue?vue&type=template&id=830fe05a"
import script from "./new-password.vue?vue&type=script&lang=ts"
export * from "./new-password.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports